import TripPanelTable from "./TripPanelTable"

export default  TripPanelTable;



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/TripPanel/TripPanelTable/index.js